import { FormEvent, useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  sendEmail,
  selector as sendEmailApi,
} from "../../../pages/users/superAdmin/organizationUsers/sendEmailSlice";
import useNotification from "../../notification/useNotification";
import { isSuccessResponse } from "../../../common/utils";
import { fetchOrganizationData } from "../../../pages/users/listOrganizationSlice";
import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { IOrganizationState } from "../../../common/types/groupTypes";

interface IOrganizationResponseState {
  organizations: IOrganizationState;
}

export const useCreateNewOrgAdmin = () => {
  const dispatch: ThunkDispatch<IOrganizationResponseState, undefined, Action> =
    useDispatch();

  const [show, setShow] = useState<boolean>(false);
  const [email, setEmail] = useState<string>("");
  const [name, setName] = useState<string>("");
  const [emailError, setEmailError] = useState<string>("");
  const [nameError, setNameError] = useState<string>("");
  const sendEmailApiResponse = useSelector(sendEmailApi);

  const handleClose = useCallback(() => {
    setShow(false);
    setEmailError("");
    setNameError("");
  }, [setShow]);
  const handleShow = useCallback(() => setShow(true), [setShow]);
  const { showSuccessNotification, showWarningNotification } =
    useNotification();
  const isValidName = (name: string): boolean => {
    if (name.trim().length === 0) {
      setNameError("Name cannot be empty or whitespaces.");
      return false;
    }
    setNameError("");
    return true;
  };
  const validateEmail = (email: string) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };
  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setEmail(e.target.value);
    setEmailError(
      validateEmail(e.target.value) ? "" : "Please enter a valid email address"
    );
  };
  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newName = e.target.value;
    if (isValidName(newName)) {
      setName(newName);
    }
  };
  const sendInvitationEmail = useCallback(async () => {
    try {
      await dispatch(sendEmail({ name, email,isReinvite:false })).then((response) => {
        if (isSuccessResponse(response.payload)) {
          showSuccessNotification(response.payload.message);
          dispatch(fetchOrganizationData());
        } else {
          showWarningNotification(response.error.message);
        }
      });
    } catch (error) {
      console.error("Error sending email:", error);
    }
  }, [dispatch, name, email]);

  const handleOnInvite = useCallback(
    (e: FormEvent) => {
      e.preventDefault();
      setShow(false);
      sendInvitationEmail();
    },
    [sendInvitationEmail]
  );

  return {
    show,
    sendEmailApiResponse,
    setEmail,
    setName,
    handleClose,
    handleShow,
    handleOnInvite,
    handleNameChange,
    handleEmailChange,
    emailError,
    nameError,
  };
};
